export default {
    creatingBreak: false,
    break: null,
    selectedChallengeId: null,
    currentPlatform: "MASTER",
    sectionsActiveGroups: {
        global: []
    },
    renamingStep: null,
    savingDisplayOrder: false,
    breakTagSearchText: "",
    breakTags: [],
    editingTags: false,
    addingTagCount: 0,
};



// WEBPACK FOOTER //
// ./public/pages/EditBreak/initialState.js